import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';



@Component
class MaintenanceListItem extends Vue {

  @Prop({ required: true, type: [Object] })
  maintenance: any;




  /**
   *
   */
  constructor() {
    super();

  }



  get lblSetting() {
    return {
      ...require('../../../../locales/maintenance').default,
      ...require('../../../../locales/ticket').default,
      /*...require('../../../../locales/generic-labels').default, */
    }
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }

  get coMaintenanceLink(): string {
    return this.isServiceBook ? `/service-book/${this.$route.params.id}/maintenances/${this.maintenance.id}`
    : `/block/${this.$route.params.id}/maintenance/${this.maintenance.id}`;
  }

  get coEquipment(): string {
    //const name: string= this.maintenance.equipment.name
    //return name.length  > 30 ? name.slice(0,27) + "..." : name
    return this.maintenance.equipment
  }

  get coSubject(): string {
    return this.maintenance.name;
  }

  get coCatSubCat(): string {
    /* return [
      this.ticket.ticket_pb_type.name,
      this.ticket.pb_character.name,
      this.ticket.pb_character_level_2.name
    ].filter(x => x && x.length > 0).join(' / ') */
    let category = this.maintenance.equipment.category.name
    if(this.maintenance.equipment.subcategory){
      let subcategory = this.maintenance.equipment.subcategory.name
      return `${category} / ${subcategory}`;
    }
    return category;
  }

  get coEquipments (): string {
    /* if (this.ticket.equipments.length > 0) {
      if (this.ticket.equipments.length === 1) {
        return this.ticket.equipments[0].name
      } else if (this.ticket.equipments.length === 2) {
        return this.ticket.equipments[0].name + this.$t(this.lblSetting.ticketOneMoreValue)
      } else if (this.ticket.equipments.length > 2) {
        return this.ticket.equipments[0].name + ' + ' + (this.ticket.equipments.length - 1) + this.$t(this.lblSetting.ticketOthersValue)
      }
    }
    return null; */
    return 'equipment'
  }

  get coContractor(): string {
    //return this.getNameFromObject(this.ticket.independents_contractors_mandate[0])
    let contractor = this.maintenance.contractor
    if(contractor==null) return null
    let firstName = contractor.firstname
    let lastName = contractor.lastname
    return `${firstName} ${lastName}`
  }

  get coCreatedDate(): string {
    return DateTimeHelper.parseDate(this.maintenance.createdAt);
  }

  get coFullNameCreator(): string {
    //return this.getNameFromObject(this.ticket.creator[0]);
    //return this.getNameFromObject(this.ticket.declarant[0]);
    //return 'coFullNameCreator'
    let creator = this.maintenance.creator
    if(creator==null) return null
    let firstName = creator.firstname
    let lastName = creator.lastname
    return `${firstName} ${lastName}`
  }

  get coLastAction(): string {
    // @ts-ignore
    return DateTimeHelper.parseDateTime(this.maintenance.updatedAt)
  }

  get coFullNameManager(): string {
    /* if (this.ticket.managers_assigned.length > 0) {
      if (this.ticket.managers_assigned.length === 1) {
        return this.getNameFromObject(this.ticket.managers_assigned[0])
      } else if (this.ticket.managers_assigned.length === 2) {
        return this.getNameFromObject(this.ticket.managers_assigned[0]) + this.$t(this.lblSetting.ticketOneMoreValue)
      } else if (this.ticket.managers_assigned.length > 2) {
        return this.getNameFromObject(this.ticket.managers_assigned[0]) + ' + ' + (this.ticket.managers_assigned.length - 1) + this.$t(this.lblSetting.ticketOthersValue)
      }
    }
    return null; */
    let manager = this.maintenance.manager_assigned
    if(manager==null) return null
    let firstName = manager.firstname
    let lastName = manager.lastname
    return `${firstName} ${lastName}`
  }

  getMaintenanceDate(date) {
    if (date) {
      return DateTimeHelper.parseDate(date);
    }
    return null;
  }

}

export default MaintenanceListItem;



// WEBPACK FOOTER //
// ./src/containers/block/block-maintenances/maintenance-list-item/index.ts